module.exports = __webpack_public_path__ + "static/img/up_start.2af7a91c.png";